<template>
  <div>
    <div class="loader" v-if="this.isLoading"></div>
    <div class="loadertext" v-if="this.isLoading">
      {{ $t("loadingTxt") }}...
    </div>
    <div class="main-wrapper" :class="{ 'blur-content': this.isLoading }">
      <!--begin::navbar-->
      <navbar-component></navbar-component>
      <!--end::navbar-->

      <div class="page-wrapper">
        <!--begin::content-->
        <div class="page-content">
          <div class="row">
            <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
              <div class="card">
                <div class="card-header">
                  <!-- <i class="link-icon float-start" data-feather="arrow-left"></i> -->
                  &nbsp;&nbsp;&nbsp;
                  <h6
                    class="card-title mb-0 float-start"
                    style="padding-left: 25px"
                  >
                    {{ $t("whActivityAddTxt") }}
                  </h6>
                  <button
                    class="btn btn-default btn-sm float-end"
                    @click="resetForm"
                    type="button"
                  >
                    <i class="link-icon" data-feather="repeat"></i>
                    {{ $t("resetFormTxt") }}
                  </button>
                </div>
                <div class="card-body">
                  <form
                    class="forms-sample"
                    @submit.prevent="submitData"
                    method="POST"
                  >
                    <div class="row">
                      <div class="row mb-3">
                        <div class="col-lg-2">
                          <label
                            for="defaultconfig"
                            class="col-form-label"
                            style="padding-left: 25px"
                            >{{ $t("customerId_txt") }}</label
                          >
                        </div>
                        <div class="col-lg-8">
                          <v-select
                            :options="fetchCompany"
                            return-object
                            label="customer_id"
                            v-model="forms.customer_id"
                            @search="asyncSearchCompany"
                            :reduce="(option) => option.customer_id"
                          >
                            <template slot="option" slot-scope="option">
                              {{ option.customer_id }} - {{ option.name }}
                            </template>
                          </v-select>

                          <div v-if="errors.customer_id">
                            <div
                              v-for="error in errors.customer_id"
                              :key="error"
                              class="alert alert-primary"
                              role="alert"
                            >
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row mb-3">
                        <div class="col-lg-2">
                          <label
                            for="defaultconfig"
                            class="col-form-label"
                            style="padding-left: 25px"
                            >{{ $t("fulfillment_code") }}</label
                          >
                        </div>
                        <div class="col-lg-8">
                          <v-select
                            :options="fetchWarehouse"
                            return-object
                            required
                            label="warehouse_id"
                            v-model="forms.warehouse_id"
                            @search="asyncSearchWarehouse"
                            :reduce="(option) => option.warehouse_id"
                          >
                            <template slot="option" slot-scope="option">
                              {{ option.warehouse_id }} - {{ option.name }}
                            </template>
                          </v-select>
                          <div v-if="errors.warehouse_id">
                            <div
                              v-for="error in errors.warehouse_id"
                              :key="error"
                              class="alert alert-primary"
                              role="alert"
                            >
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="row mb-3">
                        <div class="col-lg-2">
                          <label
                            for="defaultconfig"
                            class="col-form-label"
                            style="padding-left: 25px"
                            >{{ $t("picTxt") }}</label
                          >
                        </div>
                        <div class="col-lg-8">
                          <v-select
                            :options="fetchPic"
                            return-object
                            required
                            label="value"
                            v-model="selectedPic"
                            @search="asyncSearchPic"
                          >
                          </v-select>
                          <div v-if="errors.pic_id_employee">
                            <div
                              v-for="error in errors.pic_id_employee"
                              :key="error"
                              class="alert alert-primary"
                              role="alert"
                            >
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row mb-3">
                        <div class="col-lg-2">
                          <label
                            for="defaultconfig"
                            class="col-form-label"
                            style="padding-left: 25px"
                            >{{ $t("subjectTxt") }}</label
                          >
                        </div>
                        <div class="col-lg-8">
                          <input
                            type="text"
                            class="form-control"
                            v-model="forms.subject"
                            :id="this.$dynamicId()"
                            required
                          />

                          <div v-if="errors.subject">
                            <div
                              v-for="error in errors.subject"
                              :key="error"
                              class="alert alert-primary"
                              role="alert"
                            >
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row mb-3">
                        <div class="col-lg-2">
                          <label
                            for="defaultconfig"
                            class="col-form-label"
                            style="padding-left: 25px"
                            >{{ $t("activityDetailTxt") }}</label
                          >
                        </div>
                        <div class="col-lg-8">
                          <textarea
                            name="detail"
                            class="form-control"
                            v-model="forms.detail"
                            required
                          ></textarea>

                          <div v-if="errors.detail">
                            <div
                              v-for="error in errors.detail"
                              :key="error"
                              class="alert alert-primary"
                              role="alert"
                            >
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row mb-3">
                        <div class="row">
                          <div class="col-5">
                            <div class="row">
                              <div class="col-lg-5">
                                <label
                                  for="defaultconfig"
                                  class="col-form-label"
                                  style="padding-left: 25px"
                                  >{{ $t("activityDueDateTxt") }}</label
                                >
                              </div>
                              <div class="col-lg-7">
                                <date-picker
                                  v-model="forms.due_date"
                                  input-class="form-control"
                                  placeholder="YYYY-MM-DD"
                                  format="YYYY-MM-DD"
                                  value-type="format"
                                  type="date"
                                  :disabled-date="disabledBeforeToday"
                                  required
                                ></date-picker>

                                <div v-if="errors.due_date">
                                  <div
                                    v-for="error in errors.due_date"
                                    :key="error"
                                    class="alert alert-primary"
                                    role="alert"
                                  >
                                    <i data-feather="alert-circle"></i>
                                    {{ error }}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-5">
                            <div class="row">
                              <div class="col-lg-5">
                                <label
                                  for="defaultconfig"
                                  class="col-form-label"
                                  style="padding-left: 25px"
                                  >{{ $t("activityCloseDateTxt") }}</label
                                >
                              </div>
                              <div class="col-lg-7">
                                <date-picker
                                  v-model="forms.close_date"
                                  input-class="form-control"
                                  placeholder="YYYY-MM-DD"
                                  format="YYYY-MM-DD"
                                  value-type="format"
                                  type="date"
                                  :disabled-date="disableBeforeDueDate"
                                  :disabled="trueIfNullOrEmpty(forms.due_date)"
                                  required
                                ></date-picker>

                                <div v-if="errors.close_date">
                                  <div
                                    v-for="error in errors.close_date"
                                    :key="error"
                                    class="alert alert-primary"
                                    role="alert"
                                  >
                                    <i data-feather="alert-circle"></i>
                                    {{ error }}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row mb-3">
                        <div class="col-lg-2">
                          <label
                            for="defaultconfig"
                            class="col-form-label"
                            style="padding-left: 25px"
                            >Status</label
                          >
                        </div>
                        <div class="col-lg-8">
                          <v-select
                            :options="[{label:'Open', value:'open'},{label:'Close', value:'close'}]"
                            return-object
                            label="label"
                            :reduce="option => option.value"
                            v-model="forms.status"
                          ></v-select>

                          <div v-if="errors.status">
                            <div
                              v-for="error in errors.status"
                              :key="error"
                              class="alert alert-primary"
                              role="alert"
                            >
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row mb-3">
                        <div class="col-lg-2">
                          <label
                            for="defaultconfig"
                            class="col-form-label"
                            style="padding-left: 25px"
                            >{{ $t("remarks_txt") }}</label
                          >
                        </div>
                        <div class="col-lg-8">
                          <textarea
                            name="remarks"
                            class="form-control"
                            v-model="forms.remarks"
                          ></textarea>

                          <div v-if="errors.remarks">
                            <div
                              v-for="error in errors.remarks"
                              :key="error"
                              class="alert alert-primary"
                              role="alert"
                            >
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="card-footer">
                      <button
                        class="btn btn-warning text-black fw-bolder btn-icon-text"
                        @click="backForm"
                        type="button"
                      >
                        <i class="link-icon" data-feather="arrow-left"></i>
                        {{ $t("backMess") }}
                      </button>

                      &nbsp;&nbsp;&nbsp;
                      <button
                        class="btn btn-primary float-end btn-sm"
                        type="submit"
                      >
                        <i class="link-icon" data-feather="save"></i>
                        {{ $t("submitFormTxt") }}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
              <!--end::card-->
            </div>
          </div>
        </div>
        <!--end::content-->

        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>
  </div>
</template>

<script>
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/locale/id";

export default {
  name: "WhActivityAdd",
  props: {},
  components: {
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
    DatePicker,
  },
  data() {
    return {
      isLoading: false,
      maxToasts: 100,
      position: "up right",
      closeBtn: true,
      errors: [],
      permision_role: [],
      forms: {},
      fetchWarehouse: [],
      fetchCompany: [],
      fetchPic: [],

      selectedPic: null,
    };
  },
  watch: {
  },
  methods: {
    trueIfNullOrEmpty(val){
      let res = false;

      if(val == undefined || val == null || val == '' || val.trim() == ''){
        res = true;
      }
      return res;
    },
    disableBeforeDueDate(date){
      let selectedDate = new Date();

      let res = false;
      if(this.forms.due_date !== null && this.forms.due_date !== undefined && this.forms.due_date !== ''){
        res = true;
        selectedDate = new Date(this.forms.due_date);
        selectedDate.setHours(0,0,0,0);
      }

      if(res){
        return date < selectedDate;
      }else{
        return false;
      }
    },

    disabledBeforeToday(date) {
      const now = new Date();
      now.setHours(0, 0, 0, 0);
      return date < now;
    },

    loadWarehouse() {
      const baseURI =
        this.$settings.endpointWhMonitoring +
        "v1/warehouse/index?status=active";

      return this.$http
        .get(baseURI, { timeout: 10000 })
        .then((response) => {
          this.fetchWarehouse = response.data.datas.data;
        })
        .catch((error) => {
          this.isLoading = false;
          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else {
            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 401) {
                this.logout();
              } else if (error.response.status === 403) {
                this.$router.push("/authorized-error");
              } else if (error.response.status === 500) {
                this.$router.push("/server-error");
              } else {
                this.$router.push("/page-not-found");
              }
            }
          }
        });
    },

    asyncSearchWarehouse(ev) {
      const baseURI =
        this.$settings.endpointWhMonitoring +
        "v1/warehouse/index?status=active&warehouse_id=" +
        ev;
      this.fetchWarehouse = [];
      return this.$http
        .get(baseURI, { timeout: 10000 })
        .then((response) => {
          this.fetchWarehouse = response.data.datas.data;
        })
        .catch((error) => {
          this.isLoading = false;
          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else {
            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 401) {
                this.logout();
              } else if (error.response.status === 403) {
                this.$router.push("/authorized-error");
              } else if (error.response.status === 500) {
                this.$router.push("/server-error");
              } else {
                this.$router.push("/page-not-found");
              }
            }
          }
        });
    },
    loadCompany() {
      const baseURI =
        this.$settings.endpointWhMonitoring + "v1/customer/index?status=active";

      return this.$http
        .get(baseURI, { timeout: 10000 })
        .then((response) => {
          this.fetchCompany = response.data.datas.data;
        })
        .catch((error) => {
          this.isLoading = false;
          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else {
            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 401) {
                this.logout();
              } else if (error.response.status === 403) {
                this.$router.push("/authorized-error");
              } else if (error.response.status === 500) {
                this.$router.push("/server-error");
              } else {
                this.$router.push("/page-not-found");
              }
            }
          }
        });
    },
    asyncSearchCompany(ev) {
      const baseURI =
        this.$settings.endpointWhMonitoring +
        "v1/customer/index?status=active&company_id=" +
        ev;
      this.fetchCompany = [];
      return this.$http
        .get(baseURI, { timeout: 10000 })
        .then((response) => {
          this.fetchCompany = response.data.datas.data;
        })
        .catch((error) => {
          this.isLoading = false;
          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else {
            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 401) {
                this.logout();
              } else if (error.response.status === 403) {
                this.$router.push("/authorized-error");
              } else if (error.response.status === 500) {
                this.$router.push("/server-error");
              } else {
                this.$router.push("/page-not-found");
              }
            }
          }
        });
    },
    loadPic() {
      
      const baseURI =
        this.$settings.endpointWhMonitoring +
        "v1/system-code/index?status=active&code=m_pic";


      return this.$http
        .get(baseURI, { timeout: 10000 })
        .then((response) => {
          this.fetchPic = response.data.datas.data;
        })
        .catch((error) => {
          this.isLoading = false;
          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else {
            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 401) {
                this.logout();
              } else if (error.response.status === 403) {
                this.$router.push("/authorized-error");
              } else if (error.response.status === 500) {
                this.$router.push("/server-error");
              } else {
                this.$router.push("/page-not-found");
              }
            }
          }
        });
    },
    asyncSearchPic(ev) {
      const baseURI =
        this.$settings.endpointWhMonitoring +
        "v1/system-code/index?status=active&code=m_pic&value=" +
        ev;

      this.fetchPic = [];

      return this.$http
        .get(baseURI, { timeout: 10000 })
        .then((response) => {
          this.fetchPic = response.data.datas.data;
        })
        .catch((error) => {
          this.isLoading = false;
          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else {
            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 401) {
                this.logout();
              } else if (error.response.status === 403) {
                this.$router.push("/authorized-error");
              } else if (error.response.status === 500) {
                this.$router.push("/server-error");
              } else {
                this.$router.push("/page-not-found");
              }
            }
          }
        });
    },
    resetForm() {
      this.forms.name = "";
      this.forms.username = "";
      this.forms.password = "";
      this.forms.email = "";
      this.forms.companyId = "";
      this.forms.roleId = "";
      this.company = [];
      this.role = [];
    },

    backForm() {
      window.location.href = "/user-access";
    },

    submitData() {
      this.fade(true);

      let formData = this.forms;
      if (this.selectedPic !== null) {
        formData.pic_id_employee = "-";
        formData.pic_name = this.selectedPic.value;
      }


      const baseURI = this.$settings.endpointWhMonitoring + "v1/warehouse-activity/create";
      this.$http
        .post(baseURI, formData, { timeout: 10000 })
        .then((response) => {
          this.loading();
          if (response.data.status === 200) {
            // this.errors = [];
            var params = this.$onRandom(response.data.datas.warehouse_activity_id);
            window.location.href =
              "/wh-monitoring/wh-activity/detail/" + params + "?status=200&msg=Successfully";
            this.fade(false);
          } else {
            this.errors = response.data.errors;
            this.resultError(response.data.errors);
            this.fade(false);
          }
        })
        .catch((error) => {
          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else {
            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 401) {
                this.logout();
              } else if (error.response.status === 403) {
                this.$router.push("/authorized-error");
              } else if (error.response.status === 500) {
                this.$router.push("/server-error");
              } else {
                this.$router.push("/page-not-found");
              }
            }
          }
          this.fade(false);
        });
    },

    fade(sType) {
      this.isLoading = sType;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.fade(false);
      }, 1000); // hide the message after 3 seconds
    },

    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "success",
        title: kata,
      });
    },

    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },

    fetchIt() {
      const userDatas = this.$getUserInfo();
      this.detailUser = userDatas.sub;
      this.companyCode = this.detailUser.company_detail.code;
      // this.permision_role = userDatas.sub.permision_role;
      this.companyCode = this.detailUser.company_detail.code;
      let rolePermision = [];
      userDatas.sub.permision_role.forEach(function (permision) {
        if (
          permision.permission !== null &&
          permision.permission.controller ==
            "WhMonitoringWarehouseActivityController"
        ) {
          rolePermision = permision;
          // console.log(permision);
        }
      });

      if (!rolePermision.method_create) {
        this.$router.push("/authorized-error");
      }
      this.permision_role = rolePermision;
    },

    logout() {
      const baseURI = this.$settings.endPoint + "user/logout";
      this.$http.get(baseURI, { timeout: 10000 }).then((response) => {
        console.log(response);
      });

      this.$logoutUser();
      window.location.href = "/";
    },
  },
  events: {},
  created: function () {},
  mounted() {
    this.fetchIt();
    this.loadWarehouse();
    this.loadCompany();
    this.loadPic();
  },
};
</script>
<style scoped>
button.gm-ui-hover-effect {
  visibility: hidden;
}

.blur-content {
  filter: blur(5px);
  pointer-events: none;
}
</style>
